import React from 'react';
import { Link } from 'react-router-dom';
import './PersonalCare.css';

function PostSurgeryRecovery() {
  return (
    <div className="personal-care-page">
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <Link to="/"><h1>Malach <span>Healthcare</span></h1></Link>
          </div>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
          <Link to="/#contact" className="btn btn-primary">Book Consultation</Link>
        </nav>
      </header>

      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Post Surgery Recovery Care</h1>
          <p>Safe, supported recovery at home — so you heal faster and with confidence</p>
        </div>
      </section>

      <section className="service-content">
        <div className="service-intro">
          <h2>Recovering at Home, the Right Way</h2>
          <p>
            Surgery is only the beginning of the journey. What happens in the days and weeks after is just as
            important. Malach Healthcare's Post Surgery Recovery Care provides hands-on support, medical monitoring,
            and compassionate assistance so you or your loved one can heal safely and comfortably at home.
          </p>
          <p>
            Our trained caregivers and nursing staff work alongside your surgical team's instructions to give you
            the best possible outcome — reducing complications, preventing falls, and making recovery less stressful
            for the whole family.
          </p>
        </div>

        <div className="services-list">
          <h2>What Our Post Surgery Recovery Includes</h2>
          <div className="services-grid-detail">
            <div className="service-item">
              <div className="service-item-icon">🩹</div>
              <h3>Wound Monitoring</h3>
              <p>Daily observation and care of surgical sites to detect early signs of infection</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">💊</div>
              <h3>Medication Reminders</h3>
              <p>Ensuring post-op medications are taken correctly and on schedule</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🚶</div>
              <h3>Mobility Assistance</h3>
              <p>Safe transfers, walking support, and fall prevention during early recovery</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🍽️</div>
              <h3>Nutrition & Meal Prep</h3>
              <p>Preparing nutritious meals that support healing and follow dietary guidelines</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🛁</div>
              <h3>Personal Hygiene</h3>
              <p>Bathing, grooming, and dressing assistance tailored to post-surgical limitations</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">📞</div>
              <h3>Family Communication</h3>
              <p>Regular updates to family members on recovery progress and any concerns</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🚗</div>
              <h3>Follow-up Appointments</h3>
              <p>Transportation and escort to post-surgical doctor visits and therapy sessions</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">😌</div>
              <h3>Emotional Support</h3>
              <p>Companionship and encouragement throughout the recovery process</p>
            </div>
          </div>
        </div>

        <div className="why-choose-us">
          <h2>Why Choose Malach Healthcare for Recovery?</h2>
          <ul className="benefits-list">
            <li>✓ Coordinated care aligned with your surgeon's discharge plan</li>
            <li>✓ Reduced risk of complications and hospital readmission</li>
            <li>✓ Available for short-term or extended recovery periods</li>
            <li>✓ Trained in post-surgical protocols and safety</li>
            <li>✓ Peace of mind for the whole family</li>
          </ul>
        </div>

        <div className="closing-message">
          <p>
            Your surgery is behind you — let us help make your recovery ahead as smooth and comfortable as possible.
          </p>
          <Link to="/#contact" className="btn btn-primary btn-large">Plan Your Recovery Care</Link>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>Malach <span>Healthcare</span></h3>
            <p>Empowering golden years with compassionate care.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/#services">Services</Link></li>
              <li><Link to="/#contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 740 Main St, Waltham, MA 02451</p>
            <p>📞 (781) 697-6330</p>
            <p>✉️ info@malachhealthcare.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2025 | All Rights Reserved | Malach Healthcare</p>
        </div>
      </footer>
    </div>
  );
}

export default PostSurgeryRecovery;
